import { motion } from 'framer-motion';
import { StyledLoaderContainer } from './Loader.styled';

export const Loader = () => (
  <StyledLoaderContainer>
    <motion.div
      animate={{ rotate: 360 }}
      transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
      style={{
        width: 40,
        height: 40,
        borderRadius: '50%',
        border: '3px solid rgba(74, 144, 217, 0.2)',
        borderTopColor: '#4A90D9',
      }}
    />
  </StyledLoaderContainer>
);
